<template>
  <div id="dashboard-analytics">

    <vx-card slot="no-body h-full" class="d-theme-dark-light-bg mb-base">
      <h1
        class="p-2 font-bold w-full text-primary"
        style="border-bottom: 2px solid;"
      >
        LEAD Tracker Search
      </h1>

      <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2">
        <table stripe>
          <tr>
            <td>Phone Number</td>
            <td><vs-input
              class="inputx vx-col w-full"
              placeholder="Phone Number"
              v-model="phoneNumber"
              style="margin-top: 10px;"
            /></td>
          </tr>
          <tr>
            <td>Lead ID</td>
            <td><vs-input
              class="inputx vx-col w-full"
              placeholder="Lead ID"
              v-model="leadIDd"
              style="margin-top: 10px;"
            /></td>
          </tr>

          <tr>
            <td>Pan Number</td>
            <td><vs-input
              class="inputx vx-col w-full"
              placeholder="Pan Number"
              v-model="panNumber"
              style="margin-top: 10px;"
            /></td>
          </tr>


        </table>
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <table stripe>
          <tr>
            <td>STAGE</td>
            <td>

            <select name="status" id="status" v-model="selectedDropDownStage" class="form-control" style="-webkit-appearance: menulist;">

              <option  selected value="AWAITING_DOCUMENT">AWAITING_DOCUMENT</option>
              <option  selected value="AWAITING_QUOTATION">AWAITING_QUOTATION</option>
              <option  selected value="AWAITING_APPROVAL">AWAITING_APPROVAL</option>
              <option  selected value="AWAITING_PAYMENT">AWAITING_PAYMENT</option>
              <option  selected value="NOT_ELLIGIBLE">NOT_ELLIGIBLE</option>


            </select>
          </td>
          </tr>
          <tr>
            <td>Customer ID</td>
            <td><vs-input
              class="inputx vx-col w-full"
              placeholder="Customer ID"
              v-model="custId"
              style="margin-top: 10px;"
            /></td>
          </tr>


        </table>
      </div>
    </div>
    <vs-button
      ref="loadableButton"
      id="button-with-loading"
      class="vs-con-loading__container mt-2"
      @click="searchPage()"
      type="relief"
      style="float: none !important;"
    >Search</vs-button>

      <template>
        <vs-button
          ref="loadableButton"
          id="button-with-loading"
          class="vs-con-loading__container mt-2"
          @click="csvExport(customerData)"
          type="relief"
          style="float: right;"
        >Download Lead Data</vs-button>
        <vs-table

          v-model="selected"
          pagination
          max-items="10"
          search
          :data="customerData"
        >
          <template slot="thead">
            <vs-th sort-key="customerID">Lead ID</vs-th>
            <vs-th sort-key="customerID">Customer ID</vs-th>
            <vs-th sort-key="firstName">Company</vs-th>
            <vs-th sort-key="campaignID">Name</vs-th>
            <vs-th sort-key="campaignID">Stage</vs-th>
            <vs-th sort-key="panNumber">Vehicle Number</vs-th>
            <vs-th sort-key="primaryPhoneNumber">Insurance Upto</vs-th>
            <vs-th sort-key="primaryPhoneNumber">Reg Date</vs-th>
            <vs-th sort-key="primaryPhoneNumber">Cubic Capacity</vs-th>



          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="row" :key="indextr" v-for="(row, indextr) in data">


              <vs-td >
              <router-link :to="{path:'/leaddetails', query: {data: row.leadID,sendBy:'tracker'}}"  target ="_blank">{{row.leadID}}</router-link>
              </vs-td>


              <vs-td>
                <router-link :to="{path:'/customerDetails', query: {data: row.customerID, sixthpriority: sixthPriorityFlag}}"  target ="_blank">{{row.customerID}}</router-link>
              </vs-td>

              <vs-td>
                {{row.company}}
              </vs-td>

              <vs-td>
                {{row.name}}
              </vs-td>

              <vs-td>
                {{row.stage}}
              </vs-td>

              <vs-td>
                {{row.vehicleID}}
              </vs-td>

              <vs-td>
                {{row.insuranceUpTo| moment("Do MMM, YYYY")}}
              </vs-td>

              <vs-td>
                {{row.regDate}}
              </vs-td>

              <vs-td>
                {{row.cubicCapacity}}
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </template>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      tabSelected: 1,
      custStage: [
        { text: "AWAITING_DOCUMENT", value: "AWAITING_DOCUMENT" },
        { text: "AWAITING_QUOTATION", value: "AWAITING_QUOTATION" },
        { text: "AWAITING_APPROVAL", value: "AWAITING_APPROVAL" },
        { text: "AWAITING_PAYMENT", value: "AWAITING_PAYMENT" },
        { text: "NOT_ELLIGIBLE", value: "NOT_ELLIGIBLE" }
      ],
      numberList: [
        { text: "Not Available", value: "NULL" },
        { text: "Provided", value: "P" },
        { text: "Verified", value: "1" },
        { text: "Unverified", value: "0" },
      ],
      uberList: [
        { text: "Not Available", value: "NULL" },
        { text: "Provided", value: "P" },
        { text: "Verified", value: "1" },
        { text: "Unverified", value: "0" },
      ],
      selected: [],
      custStage:[],
      selectedIndex : null,
      city : 'ALL',
      accountStatus : 'A',
              tableBoolean: true,
              selectedDropDownStage : '',
              selectedDropDownAgreement : '',
              selectedDropDownName : '',
              selectedDropDownNumber : '',

              fromDate:'',
              toDate:'',
              downloadFlag:false,
              clearTaxFlag:false,
              customerId:'',
              searchByList :'',
              comment : '',
              custIDtoSend : '',
              searchText:'',
              noOfChe : 0,
              accountStatus:'',
              progress: false,
              selected: [],
              company:'',
              companyList :[],
              employeeList: [],
              popupSelectedDropDown : '',
              stage : '',
              priority : '',
              searchFlag : false,
              LoanDetailsPopup:false,
              customerData:[],
              sixthPriorityFlag:'0',
              date:new Date(),
              phoneNumber:'',
              leadIDd:'',
              panNumber:'',
              custId:'',
              searchBYSet:'',
              sendText:'',
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      searchBy:'',


    };
  },
  components: {},
  created() {

      this.leadID = this.$route.query.searchText;
      this.searchBy = this.$route.query.searchBy

      this.$store.commit("routeChange", "start");
      var timestamp = Math.round(+new Date() / 1000);
            var userip = this.$store.getters.ipAddress;
            var data = {
              searchBy:this.searchBy,
              searchText:this.leadID,
              page:{ startIndex: 0, size: 1000 },
            };
            var msgHeader = {
                authToken: localStorage.getItem('authtoken'), //dynamic
                authLoginID: this.$store.getters.loginId,
                timestamp: timestamp,
                ipAddress: userip
            };
            var mlDashboard = {data,msgHeader};
            axios.post('mlLeadSearch', mlDashboard).then((response) => {

                const JSONData = response.data;
                if (JSONData.data.error == 0) {
                    this.$store.commit('setauthtoken', {
                        authtoken: JSONData.msgHeader.authToken
                    });
                    localStorage.setItem('authtoken',JSONData.msgHeader.authToken);



                  this.customerData = JSONData.data.customerData


                }
                else {
                    this.error = JSONData.data.message;
                    this.$store.commit('setloginId', {
                        loginid: ''
                    });
                    this.$store.commit('setauthtoken', {
                        authtoken: ''
                    });
                    this.$root.$emit('logout');
                }


                this.$store.commit("routeChange", "end");
                //this.hitLockedAccount();

            })
            .catch(error => {
              this.errorText = "Network Error";
              console.log("display Error"+this.errorText)
              this.$store.commit("routeChange", "end");


            });

  },
  methods: {
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    updateUserClick:function(user)
    {
      this.custIDtoSend = user
      this.LoanDetailsPopup = true

    },
    csvExport(arrData)
  {
    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += [
      Object.keys(arrData[0]).join("|"),
      ...arrData.map(item => Object.values(item).join("|"))
    ]
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

    const data = encodeURI(csvContent);
    // const link = document.createElement("a");
    // const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = data;
    link.setAttribute('download', 'file.csv');
    document.body.appendChild(link);
    link.click();

 },
    createLead:function(row)
    {

      this.$store.commit("routeChange", "start");
      var timestamp = Math.round(+new Date() / 1000);
            var userip = this.$store.getters.ipAddress;
            var data = {
              leadID:row.leadID,

            };
            var msgHeader = {
                authToken: localStorage.getItem('authtoken'), //dynamic
                authLoginID: this.$store.getters.loginId,
                timestamp: timestamp,
                ipAddress: userip
            };
            var mlDashboard = {data,msgHeader};
            axios.post('mlCreateCustomerFromLead', mlDashboard).then((response) => {

                const JSONData = response.data;
                if (JSONData.data.error == 0) {
                    this.$store.commit('setauthtoken', {
                        authtoken: JSONData.msgHeader.authToken
                    });
                    localStorage.setItem('authtoken',JSONData.msgHeader.authToken);



                this.refreshPage()


                }
                else {
                    this.error = JSONData.data.message;
                    this.$store.commit('setloginId', {
                        loginid: ''
                    });
                    this.$store.commit('setauthtoken', {
                        authtoken: ''
                    });
                    this.$root.$emit('logout');
                }


                this.$store.commit("routeChange", "end");
                //this.hitLockedAccount();

            })
    },

    refreshPage()
    {
      this.leadID = this.$route.query.leadID;
      this.$store.commit("routeChange", "start");
      var timestamp = Math.round(+new Date() / 1000);
            var userip = this.$store.getters.ipAddress;
            var data = {
              searchBy:"campaignID",
              searchText:Number(this.leadID),
              page:{ startIndex: 0, size: 1000 },
            };
            var msgHeader = {
                authToken: localStorage.getItem('authtoken'), //dynamic
                authLoginID: this.$store.getters.loginId,
                timestamp: timestamp,
                ipAddress: userip
            };
            var mlDashboard = {data,msgHeader};
            axios.post('mlLeadSearch', mlDashboard).then((response) => {

                const JSONData = response.data;
                if (JSONData.data.error == 0) {
                    this.$store.commit('setauthtoken', {
                        authtoken: JSONData.msgHeader.authToken
                    });
                    localStorage.setItem('authtoken',JSONData.msgHeader.authToken);



                  this.customerData = JSONData.data.customerData


                }
                else {
                    this.error = JSONData.data.message;
                    this.$store.commit('setloginId', {
                        loginid: ''
                    });
                    this.$store.commit('setauthtoken', {
                        authtoken: ''
                    });
                    this.$root.$emit('logout');
                }


                this.$store.commit("routeChange", "end");
                //this.hitLockedAccount();

            })
    },




    searchPage()
    {
      this.leadID = this.$route.query.leadID;
      this.$store.commit("routeChange", "start");
      if(this.phoneNumber != '')
      {
        this.searchBYSet = 'phoneNumber'
        this.sendText = this.phoneNumber
      }
      else if(this.leadIDd !='')
      {
        this.searchBYSet = 'leadID'
        this.sendText = this.leadIDd
      }
      else if(this.panNumber !='')
      {
        this.searchBYSet = 'panNumber'
        this.sendText = this.panNumber
      }

      else if(this.custId !='')
      {
        this.searchBYSet = 'customerID'
        this.sendText = this.custId
      }
      else
      {
        this.searchBYSet = 'Stage'
        this.sendText = this.selectedDropDownStage
      }



      var timestamp = Math.round(+new Date() / 1000);
            var userip = this.$store.getters.ipAddress;
            var data = {
              searchBy:this.searchBYSet,
              searchText:this.sendText,
              page:{ startIndex: 0, size: 1000 },
            };
            var msgHeader = {
                authToken: localStorage.getItem('authtoken'), //dynamic
                authLoginID: this.$store.getters.loginId,
                timestamp: timestamp,
                ipAddress: userip
            };
            var mlDashboard = {data,msgHeader};
            axios.post('mlLeadSearch', mlDashboard).then((response) => {

                const JSONData = response.data;
                if (JSONData.data.error == 0) {
                    this.$store.commit('setauthtoken', {
                        authtoken: JSONData.msgHeader.authToken
                    });
                    localStorage.setItem('authtoken',JSONData.msgHeader.authToken);


                    this.phoneNumber = ''
                    this.leadIDd = ''
                    this.panNumber = ''
                    this.custId = ''
                    this.selectedDropDownStage = ''
                    this.searchBYSet = ''
                    this.sendText = ''
                  this.customerData = JSONData.data.customerData


                }
                else {
                    this.error = JSONData.data.message;
                    this.$store.commit('setloginId', {
                        loginid: ''
                    });
                    this.$store.commit('setauthtoken', {
                        authtoken: ''
                    });
                    this.$root.$emit('logout');
                }


                this.$store.commit("routeChange", "end");
                //this.hitLockedAccount();

            })
    },


    updateUser : function()
          {

                this.$store.commit("routeChange", "start");

                var timestamp = Math.round(+new Date() / 1000);
                var userip = this.$store.getters.ipAddress;
                this.selectedDropDown;

                var update = {
                  updateType:'customerCredentials',
                  verificationStatus:'',
                  docSeqID:'',
                  accountNo:'',
                  bankID:'',
                  ActiveStatusFlag:'',
                  DefaultStatusFlag:'',
                  DeleteStatusFlag:'',
                  PersonalAccountFlag:'',
                  comments:this.comment,
                  cheques:JSON.stringify(this.noOfChe),
                  stage: this.popupSelectedDropDown
                };

                var data = {
                  customerID:JSON.stringify(this.custIDtoSend),
                  update : update
                };
                var msgHeader = {
                    authToken: localStorage.getItem('authtoken'),//dynamic
                    authLoginID: this.$store.getters.loginId,
                    timestamp: timestamp,
                    ipAddress: userip
                };
                this.$root.$emit('component1', false);
                var searchUser = {data, msgHeader};
                axios.post('mlClientUpdate', searchUser).then((response) => {

                    const JSONData = response.data;
                    if (JSONData.data.error == 0) {
                        this.$store.commit('setauthtoken', {
                            authtoken: JSONData.msgHeader.authToken
                        });
                        localStorage.setItem('authtoken',JSONData.msgHeader.authToken);

                    }
                    else {
                        this.error = JSONData.data.message;
                        this.$store.commit('setloginId', {
                            loginid: ''
                        });
                        this.$store.commit('setauthtoken', {
                            authtoken: ''
                        });

                        this.$root.$emit('logout');
                    }



                    this.$store.commit("routeChange", "end");
                })
          },

    clickSelect : function(index)
          {
            console.log("Display this text"+index);
            this.selectedIndex = index;

          },

          searchAPI : function() {

                  this.$store.commit("routeChange", "start");

                  var timestamp = Math.round(+new Date() / 1000);
                  var userip = this.$store.getters.ipAddress;

                  var data = {
                    searchBy:this.stage,
                    searchText:this.selectedDropDownStage,
                    fromDate:'',
                    toDate:'',
                    days:0,
                    accountStatus:this.accountStatus,
                    stage:"",
                    orderby:'customerID',
                    order:'desc',
                    city:this.city,
                    priority:this.priority,
                    nameVerified:this.selectedDropDownName,
                    numberVerified:this.selectedDropDownNumber,
                    uberAgreement:this.selectedDropDownAgreement,
                    bankAccount:this.accountNumber,
                    companyName : this.companyList,
                    page:{
                    startIndex:0,
                    size:500
                    }
                  };
                  var msgHeader = {
                      authToken: localStorage.getItem('authtoken'),//dynamic
                      authLoginID: this.$store.getters.loginId,
                      timestamp: timestamp,
                      ipAddress: userip
                  };
                  this.$root.$emit('component1', false);
                  var searchUser = {data, msgHeader};
                  const instance = axios.create();

                  // Override timeout default for the library
                  // Now all requests using this instance will wait 2.5 seconds before timing out
                  instance.defaults.timeout = 60000000;
                  instance.post('mlSearchUser', searchUser).then((response) => {

                      const JSONData = response.data;
                      if (JSONData.data.error == 0) {
                          this.$store.commit('setauthtoken', {
                              authtoken: JSONData.msgHeader.authToken
                          });
                          localStorage.setItem('authtoken',JSONData.msgHeader.authToken);

                          this.employeeList = JSONData.data.customerInfo;


                          // if (this.employeeList.length == 0) {
                          //     this.tableBoolean = false;
                          // } else {
                          //     this.tableBoolean = true;
                          // }
                          //this.$root.$emit('component1', true);
                      }
                      else {
                          this.error = JSONData.data.message;
                          // this.show('custom-template');

                      }



                      this.$store.commit("routeChange", "end");
                  })

          },
          rowClicked : function (row){
          // this.popupSelectedDropDown = row.stage;
          // this.custIDtoSend = row.cusid;

          this.$router.push({
              path: '/customerDetails',
              query: {data: row.customerID},
              props: true
          });
        },
        unlockAccount : function(user){

            progress = 0;
                this.$store.commit("routeChange", "start");
                this.progress = true;
                var timestamp = Math.round(+new Date() / 1000);
                var userip = this.$store.getters.ipAddress;
                this.selectedDropDown;



                var data = {
                  customerID:JSON.stringify(user.cusid),

                    update:[
                    {
                      updateType:'customerCredentials',
                      docSeqID:'',
                      kycStatus:'',
                      accountNo:'',
                      fatcaStatus:'',
                      accountStatus:"A",
                      verificationStatus:''
                    }
                    ]
                };
                var msgHeader = {
                    authToken: localStorage.getItem('authtoken'),//dynamic
                    authLoginID: this.$store.getters.loginId,
                    timestamp: timestamp,
                    ipAddress: userip
                };
                this.$root.$emit('component1', false);
                var searchUser = {data, msgHeader};
                axios.post('mlClientUpdate', searchUser).then((response) => {
                    progress = 1;
                    const JSONData = response.data;
                    if (JSONData.data.error == 0) {
                        this.$store.commit('setauthtoken', {
                            authtoken: JSONData.msgHeader.authToken
                        });
                        localStorage.setItem('authtoken',JSONData.msgHeader.authToken);


                          this.data.rows = [];
                          this.rows =  this.data.rows;

                          this.searchAPI();


                    }
                    else {
                        this.error = JSONData.data.message;
                        this.$store.commit('setloginId', {
                            loginid: ''
                        });
                        this.$store.commit('setauthtoken', {
                            authtoken: ''
                        });

                        this.$root.$emit('logout');
                    }

                    this.progress = false;

                    this.$store.commit("routeChange", "end");
                })

          },

  },
    watch: {

    }
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
